<template>
  <el-dialog
    v-if="dialogVisible"
    :title="title"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="cancelHandler"
  >
    <div class="container">
      <span v-if="withdrawalType == 'success'"
        >该合同已撤回成功，合同状态为【已保存】<br />
        请点击合同详情进行修改后提交审批</span
      >
      <span v-else>该合同已完成审批，不可进行撤回 <br />请先关闭合同再重新申请</span>
    </div>
    <div class="btn-group">
      <el-button @click="confirmHandler" v-if="withdrawalType == 'success'">确 认</el-button>
      <el-button @click="confirmCloseHandler" v-else>关闭合同</el-button>
      <el-button @click="cancelHandler" type="primary">取 消</el-button>
    </div>
    <CloseContractDialog ref="closeContractDialogRef" @refreshTable="refreshTable" />
  </el-dialog>
</template>

<script>
  import CloseContractDialog from '@/pages/superviseContract/SuperviseContractDetail/components/CloseContractDialog/index.vue';
  export default {
    name: 'WithdrawalDialog',
    props: {
      withdrawalType: {
        type: String,
        default: 'success',
      },
    },
    data() {
      return {
        dialogVisible: false,
        rowData: {},
      };
    },
    computed: {
      title() {
        if (this.withdrawalType == 'success') {
          return '监管合同撤回成功提示';
        } else {
          return '监管合同撤回失败提示';
        }
      },
    },
    methods: {
      openDialog(rowData = {}) {
        this.rowData = rowData;
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
        this.$emit('refreshTable');
      },
      confirmHandler() {
        this.cancelHandler();
      },
      // 关闭合同
      confirmCloseHandler() {
        const contractStatus = this.rowData?.contractStatus;
        const id = this.rowData?.id;
        this.$refs.closeContractDialogRef.openDialog(id, contractStatus);
      },
      refreshTable() {
        this.cancelHandler();
      },
    },
    components: {
      CloseContractDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    text-align: center;
  }
  .btn-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 30px;
  }
</style>
